import React, { useEffect, useState } from 'react';
import api from '../services/api';

const TABS = ['Priority', 'Status', 'Category', 'SLA'];

export default function Masters() {
  const [tab, setTab] = useState('Priority');
  const [priorities, setPriorities] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subs, setSubs] = useState([]);
  const [slas, setSlas] = useState([]);
  const [companies, setCompanies] = useState([]);

  const [modal, setModal] = useState(null); // { kind, item }
  const [form, setForm] = useState({});
  const [err, setErr] = useState('');

  const load = async () => {
    const [p, s, c, sub, sl, co] = await Promise.all([
      api.get('/priorities').catch(() => ({ data: [] })),
      api.get('/statuses').catch(() => ({ data: [] })),
      api.get('/categories').catch(() => ({ data: [] })),
      api.get('/categories/subcategories/all').catch(() => ({ data: [] })),
      api.get('/slas').catch(() => ({ data: [] })),
      api.get('/companies').catch(() => ({ data: [] })),
    ]);
    setPriorities(p.data); setStatuses(s.data); setCategories(c.data);
    setSubs(sub.data); setSlas(sl.data); setCompanies(co.data);
  };
  useEffect(() => { load(); }, []);

  const priName = (id) => priorities.find(x => x.id === id)?.name || '—';
  const coName = (id) => companies.find(x => x.id === id)?.name || 'All customers';

  const openNew = (kind, defaults = {}) => { setModal({ kind, item: null }); setForm(defaults); setErr(''); };
  const openEdit = (kind, item) => { setModal({ kind, item }); setForm({ ...item }); setErr(''); };

  const save = async () => {
    setErr('');
    const { kind, item } = modal;
    try {
      if (kind === 'Priority') {
        const b = { name: form.name, level: Number(form.level) || 0, color: form.color, active: form.active !== false };
        item ? await api.put(`/priorities/${item.id}`, b) : await api.post('/priorities', b);
      } else if (kind === 'Status') {
        const b = { name: form.name, sortOrder: Number(form.sortOrder) || 0, closed: !!form.closed, color: form.color, active: form.active !== false };
        item ? await api.put(`/statuses/${item.id}`, b) : await api.post('/statuses', b);
      } else if (kind === 'Category') {
        const b = { name: form.name, description: form.description, active: form.active !== false };
        item ? await api.put(`/categories/${item.id}`, b) : await api.post('/categories', b);
      } else if (kind === 'Subcategory') {
        const b = { name: form.name, active: form.active !== false };
        item ? await api.put(`/categories/subcategories/${item.id}`, b) : await api.post(`/categories/${form.categoryId}/subcategories`, b);
      } else if (kind === 'SLA') {
        const b = {
          name: form.name, priorityId: form.priorityId ? Number(form.priorityId) : null,
          companyId: form.companyId ? Number(form.companyId) : null,
          responseMinutes: form.responseMinutes ? Number(form.responseMinutes) : null,
          resolutionMinutes: form.resolutionMinutes ? Number(form.resolutionMinutes) : null,
          active: form.active !== false,
        };
        if (!b.priorityId) { setErr('Priority is required'); return; }
        item ? await api.put(`/slas/${item.id}`, b) : await api.post('/slas', b);
      }
      setModal(null); load();
    } catch (e) { setErr(e.response?.data?.error || 'Save failed'); }
  };

  const Th = ({ children }) => <th>{children}</th>;
  const EditBtn = ({ onClick }) => <button className="btn-ghost" style={{ padding: '4px 10px', fontSize: 12 }} onClick={onClick}>Edit</button>;
  const Badge = ({ on }) => <span className={`badge ${on ? 'badge-success' : 'badge-gray'}`}>{on ? 'Active' : 'Inactive'}</span>;

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, color: '#0f172a' }}>Masters</h1>
      <p style={{ color: '#64748b', marginBottom: 16 }}>Configurable support master data</p>

      <div style={{ display: 'flex', gap: 8, marginBottom: 16 }}>
        {TABS.map(t => (
          <button key={t} className={tab === t ? 'btn-primary' : 'btn-ghost'} onClick={() => setTab(t)}>{t}</button>
        ))}
      </div>

      <div className="card" style={{ padding: 0, overflow: 'hidden' }}>
        {tab === 'Priority' && (
          <>
            <Bar title="Priorities" onAdd={() => openNew('Priority', { level: 1, active: true })} />
            <table><thead><tr><Th>Name</Th><Th>Level</Th><Th>Color</Th><Th>Status</Th><Th></Th></tr></thead>
              <tbody>{priorities.map(p => <tr key={p.id}><td style={{ fontWeight: 600 }}>{p.name}</td><td>{p.level}</td><td><span style={{ display: 'inline-block', width: 14, height: 14, borderRadius: 4, background: p.color || '#ccc', verticalAlign: 'middle' }} /> {p.color}</td><td><Badge on={p.active} /></td><td><EditBtn onClick={() => openEdit('Priority', p)} /></td></tr>)}</tbody>
            </table>
          </>
        )}
        {tab === 'Status' && (
          <>
            <Bar title="Statuses" onAdd={() => openNew('Status', { sortOrder: 0, active: true })} />
            <table><thead><tr><Th>Name</Th><Th>Order</Th><Th>Terminal</Th><Th>Status</Th><Th></Th></tr></thead>
              <tbody>{statuses.map(s => <tr key={s.id}><td style={{ fontWeight: 600 }}>{s.name}</td><td>{s.sortOrder}</td><td>{s.closed ? 'Yes' : '—'}</td><td><Badge on={s.active} /></td><td><EditBtn onClick={() => openEdit('Status', s)} /></td></tr>)}</tbody>
            </table>
          </>
        )}
        {tab === 'Category' && (
          <>
            <Bar title="Categories & Subcategories" onAdd={() => openNew('Category', { active: true })} />
            <div style={{ padding: 16 }}>
              {categories.length === 0 && <div style={{ color: '#94a3b8', fontSize: 13 }}>No categories yet.</div>}
              {categories.map(c => (
                <div key={c.id} style={{ border: '1px solid var(--gray-200)', borderRadius: 10, padding: 12, marginBottom: 10 }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ fontWeight: 600 }}>{c.name} <Badge on={c.active} /></div>
                    <div style={{ display: 'flex', gap: 6 }}>
                      <button className="btn-ghost" style={{ padding: '3px 10px', fontSize: 12 }} onClick={() => openNew('Subcategory', { categoryId: c.id, active: true })}>+ Subcategory</button>
                      <EditBtn onClick={() => openEdit('Category', c)} />
                    </div>
                  </div>
                  <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 8 }}>
                    {subs.filter(s => s.categoryId === c.id).map(s => (
                      <span key={s.id} onClick={() => openEdit('Subcategory', s)} style={{ cursor: 'pointer', fontSize: 12, background: 'var(--gray-100)', borderRadius: 999, padding: '4px 12px' }}>{s.name}</span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </>
        )}
        {tab === 'SLA' && (
          <>
            <Bar title="SLA Policies" onAdd={() => openNew('SLA', { active: true })} />
            <table><thead><tr><Th>Name</Th><Th>Priority</Th><Th>Customer</Th><Th>Response (min)</Th><Th>Resolution (min)</Th><Th>Status</Th><Th></Th></tr></thead>
              <tbody>{slas.map(s => <tr key={s.id}><td style={{ fontWeight: 600 }}>{s.name}</td><td>{priName(s.priorityId)}</td><td>{coName(s.companyId)}</td><td>{s.responseMinutes ?? '—'}</td><td>{s.resolutionMinutes ?? '—'}</td><td><Badge on={s.active} /></td><td><EditBtn onClick={() => openEdit('SLA', s)} /></td></tr>)}</tbody>
            </table>
          </>
        )}
      </div>

      {modal && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 }} onClick={() => setModal(null)}>
          <div style={{ background: '#fff', borderRadius: 14, padding: 28, width: 420, boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }} onClick={e => e.stopPropagation()}>
            <h3 style={{ fontWeight: 700, marginBottom: 18, color: '#0f172a' }}>{modal.item ? 'Edit' : 'New'} {modal.kind}</h3>
            {err && <div style={{ background: '#fee2e2', color: '#b91c1c', borderRadius: 8, padding: '10px 14px', marginBottom: 14, fontSize: 13 }}>{err}</div>}

            <F label="Name *"><input value={form.name || ''} onChange={e => setForm({ ...form, name: e.target.value })} /></F>
            {modal.kind === 'Priority' && <>
              <F label="Level"><input type="number" value={form.level ?? ''} onChange={e => setForm({ ...form, level: e.target.value })} /></F>
              <F label="Color"><input type="color" value={form.color || '#3b82f6'} onChange={e => setForm({ ...form, color: e.target.value })} style={{ height: 40 }} /></F>
            </>}
            {modal.kind === 'Status' && <>
              <F label="Sort Order"><input type="number" value={form.sortOrder ?? ''} onChange={e => setForm({ ...form, sortOrder: e.target.value })} /></F>
              <F label=""><label style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" checked={!!form.closed} onChange={e => setForm({ ...form, closed: e.target.checked })} style={{ width: 'auto' }} /> Terminal state (stops SLA / counts as done)</label></F>
            </>}
            {modal.kind === 'Category' && <F label="Description"><input value={form.description || ''} onChange={e => setForm({ ...form, description: e.target.value })} /></F>}
            {modal.kind === 'SLA' && <>
              <F label="Priority *"><select value={form.priorityId || ''} onChange={e => setForm({ ...form, priorityId: e.target.value })}><option value="">— Select —</option>{priorities.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}</select></F>
              <F label="Customer (blank = default)"><select value={form.companyId || ''} onChange={e => setForm({ ...form, companyId: e.target.value })}><option value="">All customers (default)</option>{companies.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}</select></F>
              <F label="Response (minutes)"><input type="number" value={form.responseMinutes ?? ''} onChange={e => setForm({ ...form, responseMinutes: e.target.value })} /></F>
              <F label="Resolution (minutes)"><input type="number" value={form.resolutionMinutes ?? ''} onChange={e => setForm({ ...form, resolutionMinutes: e.target.value })} /></F>
            </>}
            <F label=""><label style={{ fontSize: 13, display: 'flex', gap: 8, alignItems: 'center' }}><input type="checkbox" checked={form.active !== false} onChange={e => setForm({ ...form, active: e.target.checked })} style={{ width: 'auto' }} /> Active</label></F>

            <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
              <button className="btn-primary" onClick={save} style={{ flex: 1 }}>{modal.item ? 'Update' : 'Create'}</button>
              <button className="btn-ghost" onClick={() => setModal(null)} style={{ flex: 1 }}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function Bar({ title, onAdd }) {
  return (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 16px', borderBottom: '1px solid var(--gray-200)' }}>
      <div style={{ fontWeight: 600 }}>{title}</div>
      <button className="btn-primary" style={{ fontSize: 13, padding: '6px 14px' }} onClick={onAdd}>+ Add</button>
    </div>
  );
}

function F({ label, children }) {
  return (
    <div style={{ marginBottom: 12 }}>
      {label && <label style={{ fontSize: 13, fontWeight: 500, display: 'block', marginBottom: 4, color: '#374151' }}>{label}</label>}
      {children}
    </div>
  );
}
